// components/MainProductSlider.jsx
import { useState, useEffect, useRef } from 'react';
import classes from './MainProductSlider.module.scss';
import Image from 'next/image';
import Slider from 'react-slick';

const MainProductSlider = ({ product, timeout = 0 }) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const images = product.content?.media || [];

  const mainSlider = useRef(null);
  const thumbSlider = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, timeout);
    return () => clearTimeout(timer);
  }, [timeout]);

  if (!isLoaded || images.length === 0) {
    return null;
  }

  // Configuration for main slider
  const settingsMain = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    asNavFor: thumbSlider.current,
  };

  // Configuration for thumbs slider
  const settingsThumbs = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(images.length, 4),
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: false,
    centerMode: false,
    asNavFor: mainSlider.current,
  };

  return (
    <div className={classes['product-slider']}>
      <Slider
        {...settingsMain}
        ref={mainSlider}
        className={classes['product-image']}
      >
        {images.map((image, index) => (
          <div key={`${image.id}-${index}`} className={classes['slide']}>
            <div className={classes['image-wrapper']}>
              <Image
                sizes="(min-width: 1080px) 50vw, 100vw"
                src={image.src}
                alt={image.altText || product.content?.title}
                className={classes['image']}
                layout="fill"
                objectFit="cover"
              />
            </div>
          </div>
        ))}
      </Slider>

      {images.length > 1 && (
        <Slider
          {...settingsThumbs}
          ref={thumbSlider}
          className={classes['product-image-thumbnails']}
        >
          {images.map((image, index) => (
            <div key={`${image.id}-${index}`} className={classes['thumbnail-slide']}>
              <div className={classes['thumbnail-wrapper']}>
                <Image
                  loader={({ src }) => `${src}?w=300`}
                  className={classes['thumbnail-image']}
                  src={image.src}
                  layout="fill"
                  objectFit="cover"
                  alt={image.altText || product.content?.title}
                />
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default MainProductSlider;
